import React from 'react';
import './Layout.css';
import logo from '../assets/images/coop-logo-white.svg';

// Page footer component. Contains the help link.
export default function Footer(props) {
    return (
        <>
            <div className="help-link">
                <a href={process.env.REACT_APP_HELP_LINK} target="_blank"><p>Help</p> <i className="fa fa-question-circle"></i></a>
            </div>

            <div className="footer" >
                <img src={logo} className="footer-logo" alt="Co-op" />&copy; {new Date().getFullYear()} Federated Co<span style={{fontFamily: "system-ui"}}>‑</span>operatives Limited
            </div>
        </>
    )
}